import { useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
import {
  InvestmentInfoFormikType,
  investmentInfoValidation,
  investmentInfoInitialValues,
  investmentInfoOnSubmit,
} from 'views/utils/accountEstablish';
import { AccountInfoUpdateRequestParam, useAccountInfoUpdateStore } from './useUpdatePage';

export const useInvestmentInfoUpdate = () => {
  const { param, add } = useAccountInfoUpdateStore();
  const initialValues = investmentInfoInitialValues(param);
  const onSubmit = investmentInfoOnSubmit<AccountInfoUpdateRequestParam>(param, add);

  const formik: InvestmentInfoFormikType = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: investmentInfoValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  return {
    formik,
  };
};
